export const NAVBAR_BLOCK_s10 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#F7F7F8",
    "padding": "10px 0px 10px 0px"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "꩜ Onic",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#333333",
      "font-family": "'Lato', sans-serif",
      "line-height": "2.25rem",
      "font-family-bk": "'Lato', sans-serif",
      "font-weight": "900"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "Features",
      "linkUrl": "/features",
      "styleProps": {
        "color": "",
        "padding": "14px 34px 14px 34px",
        "margin": "0px 0px 0px 0px"
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Services",
      "linkUrl": "/services",
      "styleProps": {
        "color": "",
        "padding": "14px 34px 14px 34px",
        "margin": "0px 0px 0px 0px"
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Docs",
      "linkUrl": "/docs",
      "styleProps": {
        "color": "",
        "padding": "14px 34px 14px 34px",
        "margin": "0px 0px 0px 0px"
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Pricing",
      "linkUrl": "/pricing",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "",
        "padding": "14px 34px 14px 34px",
        "margin": "0px 0px 0px 120px"
      }
    },
    {
      "text": "Get Started",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#ffffff",
        "border-width": "0px",
        "border-radius": "1rem",
        "padding": "14px 30px 14px 30px",
        "margin": "0px 0px 0px 20px",
        "border-color": "#4f4f4f",
        "background-color": "",
        "background-image": "linear-gradient(to left,#7F7FD5,#91EAE4)"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#333333",
    "border-color": "#333333"
  },
  "metaDataId": 1746278539892,
  "afterIndex": 8,
  "blockId": 1746278539892,
  "linksStyleProps": {
    "color": "#333333",
    "padding": "14px 0px 14px 0px",
    "font-weight": "500",
    "font-size": "1.125rem",
    "line-height": "1.75rem"
  }
}